var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86612 5.36612C6.35427 4.87796 7.14573 4.87796 7.63388 5.36612L10.5 8.23223L13.3661 5.36612C13.8543 4.87796 14.6457 4.87796 15.1339 5.36612C15.622 5.85427 15.622 6.64573 15.1339 7.13388L12.2678 10L15.1339 12.8661C15.622 13.3543 15.622 14.1457 15.1339 14.6339C14.6457 15.122 13.8543 15.122 13.3661 14.6339L10.5 11.7678L7.63388 14.6339C7.14573 15.122 6.35427 15.122 5.86612 14.6339C5.37796 14.1457 5.37796 13.3543 5.86612 12.8661L8.73223 10L5.86612 7.13388C5.37796 6.64573 5.37796 5.85427 5.86612 5.36612Z",
    fill: "#D00026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon_remove.dbf547ab757353bb3ce8d56f34bc1e36.svg";
export { ForwardRef as ReactComponent };